import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import ViewModel from '@bingads-webui-campaign-legacy/bidlandscape/viewmodel/bid-landscape';
import highchartsConfig from '@bingads-webui-campaign-legacy/bidlandscape/viewmodel/highcharts-config';
import 'highcharts';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/bidlandscape');

function percentileCeil(original) {
  const floor = Math.floor(original * 100) / 100;

  return floor + 0.01;
}

/**
 * @fires update
 * @fires input
 * @fires apply
 * @fires cancel
 */
export default class BidLandscape extends Backbone.View {
  get events() {
    return {
      'click .btn-primary': 'onApply',
      'click .btn-default': 'onCancel',
      'click .closeimage': 'onCancel',
    };
  }

  initialize({
    parentItem = {},
    viewModel = null,
    helpId = null,
    inSimpleMode = false,
    dataToShow = {},
  } = {}) {
    this.parentItem = parentItem;
    this.viewModel = viewModel || new ViewModel(this.parentItem, this);
    if (!_.isEmpty(helpId)) {
      this.viewModel.helpId(helpId);
    }
    this.viewModel.i18n = i18n;
    this.slideChartOptions = null;
    this.viewModel.inSimpleMode(inSimpleMode);

    this.viewModel.valueToApply.subscribe((value) => {
      /**
       * update event.
       *
       * @event BidLandscape#update
       * @type {object}
       * @property {?string} valueToApply - the bid value to apply.
       * @property {boolean} inputValid - the bid is valid or not.
       */
      this.trigger('update', {
        valueToApply: value,
        inputValid: this.viewModel.inputValid(),
      });
      if (this.viewModel.currentSelectedId() === this.viewModel.landscapePointsLength()) {
        /**
         * user input event.
         *
         * @event BidLandscape#input
         * @type {string}
         */
        this.trigger('input', this.viewModel.userInput());
      }
    });

    this.dataToShow = dataToShow;
  }

  /**
   * Setup template.
   * @abstract
   * @returns {void}
   */
  prepareView() {
    throw new TypeError('sub class should implement this function');
  }

  /**
   * Need extra chart series preparation or not, if need, this is an series data array.
   * @abstract
   * @returns {?array} - extra chart series data.
   */
  prepareExtraSeries() {
    return null;
  }

  onApply() {
    /**
     * apply event.
     *
     * @event BidLandscape#apply.
     */
    this.trigger('apply');
  }

  onCancel() {
    /**
     * cancel event.
     *
     * @event BidLandscape#cancel.
     */
    this.trigger('cancel');
  }

  inputValueInvalid(msg) {
    this.viewModel.inputInvalidByUser(!_.isEmpty(msg));
    if (!_.isEmpty(msg)) {
      this.viewModel.inputErrorMessage(msg);
    }
  }

  render() {
    this.prepareView();
    this.viewModel.convertDataForBidLandscape(this.dataToShow);
    this.initBidLandscapeCharts();

    ko.applyBindings(this.viewModel, this.el);
    this.delegateEvents();
    return this;
  }

  close() {
    this.remove();
  }

  getTableKpiIndex4Point(data, clickEvent) {
    const kpiIndexInSortOrder = clickEvent && clickEvent === 'true' ? data.index : data.point.index;

    return this.viewModel.landscapePointsLength() - 1 - kpiIndexInSortOrder;
  }

  selectionUpdated() {
    // trigger keydown each time select custom input
    if (this.viewModel.currentSelectedId() >= this.viewModel.landscapePointsLength()) {
      this.$('.bidlandscape-input').trigger('keydown');
    }

    this.$('.bidlandscape-chart').highcharts(this.initSlideChartForBid());  //render landscape chart
  }

  landscapePointClicked(event, pointClicked) {
    const tableKPiIndex = this.getTableKpiIndex4Point(pointClicked, 'true');

    if (_.isNumber(tableKPiIndex)) {
      this.viewModel.currentSelectedId(tableKPiIndex);
    }
  }

  initBidLandscapeCharts() {
    this.slideChartOptions = highchartsConfig.getBidlandscapeChartOptions(this.viewModel.isClickGraph());
    // add click event for highcharts
    const self = this;

    this.slideChartOptions.plotOptions.series.point.events.click = function (event) {
      event.stopImmediatePropagation();
      self.landscapePointClicked(event, this);
    };
  }

  clickCurrentRow() {
    this.selectionUpdated();
  }

  initSlideChartForBid() {
    this.slideChartOptions =  this.slideChartOptions || highchartsConfig.getBidlandscapeChartOptions(this.viewModel.isClickGraph());
    // draw chart
    let maxIndex = -1;
    let maxX = 0,
      maxY = 0,
      minX = -1,
      minY = -1;
    const xAxisName = this.viewModel.isClickGraph() ? i18n.get('KPI_EstClick') : this.viewModel.tableBidText();
    const title = this.viewModel.isClickGraph() ? i18n.get('KPI_EstCost') : i18n.get('KPI_EstImp');
    let graphPoint;

    this.slideChartOptions.xAxis.title.text = xAxisName.toUpperCase();
    this.slideChartOptions.yAxis.title.text = title.toUpperCase();
    const seriesData = _.map(this.viewModel.dataArray(), (point, index) => {
      if (point.bid > 0) {
        graphPoint = {
          x: this.viewModel.isClickGraph() ? point.clicks : point.bid,
          y: this.viewModel.isClickGraph() ? point.cost : point.impressions,
          index, // index in tableData
        };

        if (maxIndex < 0) {
          maxX = graphPoint.x;
          maxY = graphPoint.y;
          maxIndex = index;
        }

        minX = minX > 0 && minX <= graphPoint.x ? minX : graphPoint.x;
        minY = minY > 0 && minY <= graphPoint.y ? minY : graphPoint.y;

        if ((this.viewModel.currentSelectedId() >= 0) && (index === this.viewModel.currentSelectedId())) {
          graphPoint = _.extend(graphPoint, highchartsConfig.getMakerSetting());
        }
      }
      return graphPoint;
    });

    this.slideChartOptions.series = [];
    this.slideChartOptions.series.push({
      name: xAxisName,
      data: seriesData.reverse(),
    });

    // let son class finish extra series preparation
    const extraSeries = this.prepareExtraSeries();

    if (_.isObject(extraSeries)) {
      this.slideChartOptions.series.push({
        data: extraSeries,
      });
    }

    this.slideChartOptions.xAxis.min = minX;
    this.slideChartOptions.yAxis.min = minY;
    this.slideChartOptions.xAxis.max = percentileCeil(maxX);
    this.slideChartOptions.yAxis.max = percentileCeil(maxY);

    return this.slideChartOptions;
  }

  hasData() {
    return this.viewModel.hasData();
  }

  valueToApply() {
    return this.viewModel.valueToApply();
  }

  inputValid() {
    return this.viewModel.inputValid();
  }
}
